import React from 'react';
import { PageArray } from './debug-banners/PageArray';
import { ConditionalBaseBuilder } from './debug-banners/ConditionalBaseBuilder';
import { PageAndFieldValidity } from './debug-banners/PageAndFieldValidity';
import { PageAndFieldValidityForCurrentPage } from './debug-banners/PageAndFieldValidityForCurrentPage';
import { FormValuesDisplay } from './debug-banners/FormValuesDisplay';
import { DeleteFormValues } from './debug-banners/DeleteFormValues';
import { Grid, GridItem, Toggle } from '@flos/react-ui';

// @TODO
//   - Calculate the optimal grid span
const DebugBanners = () => {
    const [showConditionalPageArray, setShowConditionalPageArray] = React.useState(false);
    const [showConditionalBaseBuilder, setShowConditionalBaseBuilder] = React.useState(false);
    const [showValidity, setShowValidity] = React.useState(false);
    const [showValidityForCurrentPage, setShowValidityForCurrentPage] = React.useState(false);
    const [showFormValues, setShowFormValues] = React.useState(false);
    const [deleteFormValues, setDeleteFormValues] = React.useState(false);

    return (
        <>
            <Grid className="u-Space">
                <GridItem span={1}>
                    <Toggle id="showFormValues" onChange={(event) => setShowFormValues(event.target.checked)} />
                </GridItem>
                <GridItem span={11}>Show form values</GridItem>
            </Grid>

            <Grid className="u-Space">
                <GridItem span={1}>
                    <Toggle id="deleteFormValues" onChange={(event) => setDeleteFormValues(event.target.checked)} />
                </GridItem>
                <GridItem span={11}>Delete form values</GridItem>
            </Grid>

            <Grid className="u-Space">
                <GridItem span={1}>
                    <Toggle id="showValidity" onChange={(event) => setShowValidity(event.target.checked)} />
                </GridItem>
                <GridItem span={11}>Show page and field validity</GridItem>
            </Grid>

            <Grid className="u-Space">
                <GridItem span={1}>
                    <Toggle
                        id="showValidityForCurrentPage"
                        onChange={(event) => setShowValidityForCurrentPage(event.target.checked)}
                    />
                </GridItem>
                <GridItem span={11}>Show page and field validity for current page</GridItem>
            </Grid>

            <Grid className="u-Space">
                <GridItem span={1}>
                    <Toggle
                        id="showConditionalPageArray"
                        onChange={(event) => setShowConditionalPageArray(event.target.checked)}
                    />
                </GridItem>
                <GridItem span={11}>Show conditional page array</GridItem>
            </Grid>

            <Grid className="u-Space">
                <GridItem span={1}>
                    <Toggle
                        id="showConditionalBaseBuilder"
                        onChange={(event) => setShowConditionalBaseBuilder(event.target.checked)}
                    />
                </GridItem>
                <GridItem span={11}>Show conditional base buildder</GridItem>
            </Grid>

            <Grid className="u-Space">
                {showConditionalPageArray ? (
                    <GridItem span={6}>
                        <PageArray />
                    </GridItem>
                ) : (
                    <></>
                )}

                {deleteFormValues ? (
                    <GridItem span={6}>
                        <DeleteFormValues />
                    </GridItem>
                ) : (
                    <></>
                )}

                {showConditionalBaseBuilder ? (
                    <GridItem span={6}>
                        <ConditionalBaseBuilder />
                    </GridItem>
                ) : (
                    <></>
                )}

                {showValidity ? (
                    <GridItem span={6}>
                        <PageAndFieldValidity />
                    </GridItem>
                ) : (
                    <></>
                )}

                {showValidityForCurrentPage ? (
                    <GridItem span={6}>
                        <PageAndFieldValidityForCurrentPage />
                    </GridItem>
                ) : (
                    <></>
                )}

                {showFormValues ? (
                    <GridItem span={6}>
                        <FormValuesDisplay />
                    </GridItem>
                ) : (
                    <></>
                )}
            </Grid>
        </>
    );
};

export default DebugBanners;
